// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"5b5bf149","453":"3e67d6b1"}[chunkId] + ".chunk.js";
};